/** If-then cues offered at the start ("After my morning coffee, I do my Greek"). */
export const HABITS = [
  'After my morning coffee',
  'On my commute',
  'After lunch',
  'Before dinner',
  'Before bed',
];

/** The learner's cue, said back to them: "After my morning coffee" → "after your morning coffee". */
export function yourHabit(habit: string): string {
  const said = habit
    .trim()
    .replace(/\bmy\b/gi, 'your')
    .replace(/\bI['’]m\b/g, "you're")
    .replace(/\bI\b/g, 'you');
  return said.charAt(0).toLowerCase() + said.slice(1);
}
